import { render, staticRenderFns } from "./CourseOutstanding.vue?vue&type=template&id=1cf57455"
import script from "./CourseOutstanding.vue?vue&type=script&lang=js"
export * from "./CourseOutstanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports